import React from "react";

export default function SpinnerOverlay({ text = "Processing..." }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
      <div className="flex flex-col items-center gap-6">
        <div className="h-16 w-16 animate-spin rounded-full border-[6px] border-white/30 border-t-[#fa9324]" />

        <p className="text-lg font-semibold tracking-wide text-white">
          {text}
        </p>
      </div>
    </div>
  );
}